const DEFAULT_POLL_INTERVAL_MS = 50
const DEFAULT_READY_TIMEOUT_MS = 10000

export function readSiteKey() {
    return typeof window !== 'undefined' && typeof window.calcRecaptchaSiteKey === 'string'
        ? window.calcRecaptchaSiteKey
        : ''
}

export function whenRecaptchaReady({
    pollIntervalMs = DEFAULT_POLL_INTERVAL_MS,
    timeoutMs = DEFAULT_READY_TIMEOUT_MS,
} = {}) {
    return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && typeof window?.grecaptcha?.render === 'function') {
            resolve()
            return
        }
        const startedAt = Date.now()
        const id = setInterval(() => {
            if (typeof window !== 'undefined' && typeof window?.grecaptcha?.render === 'function') {
                clearInterval(id)
                resolve()
                return
            }
            if (Date.now() - startedAt > timeoutMs) {
                clearInterval(id)
                reject(new Error('recaptcha-timeout'))
            }
        }, pollIntervalMs)
    })
}
